module.exports = __webpack_public_path__ + "img/home.6a7ad68a.svg";